import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      handleUser: (user) => set({ user }),
    }),
    {
      name: 'user-storage',
    }
  )
)
